import { Action } from '@ngrx/store';

export enum ECustomerMissionActions {
  SaveCustomerMission = '[CUSTOMER_MISSION] Save customer mission',
  UpdateCustomerMission = '[CUSTOMER_MISSION] Update customer mission',
  SaveCustomerMissionSuccess = '[CUSTOMER_MISSION] Save customer mission success',
  SaveCustomerMissionFailure = '[CUSTOMER_MISSION] Save customer mission failure'
}

export class SaveCustomerMission implements Action {
  public readonly type = ECustomerMissionActions.SaveCustomerMission;
  constructor(public payload: any, public procedureCode: string, public procedureType: string) {}
}

export class UpdateCustomerMission implements Action {
  public readonly type = ECustomerMissionActions.UpdateCustomerMission;
  constructor(public payload: any, public procedureCode: string, public procedureType: string) {}
}

export class SaveCustomerMissionSuccess implements Action {
  public readonly type = ECustomerMissionActions.SaveCustomerMissionSuccess;
  constructor(public payload: any) {}
}

export class SaveCustomerMissionFailure implements Action {
  public readonly type = ECustomerMissionActions.SaveCustomerMissionFailure;
}

export type SaveCustomerMissionActions = SaveCustomerMission | UpdateCustomerMission | SaveCustomerMissionSuccess | SaveCustomerMissionFailure;
